import Sms from '@lib//containers/Sms';
import Alarm from '@lib/containers//Alarm';
import LogEvent from '@lib/containers//LogEvent';
import ChangePassword from '@lib/containers/ChangePassword';
import DashBoard from '@lib/containers/DashBoard';
import Home from '@lib/containers/Home';
import Input from '@lib/containers/Input';
import Login from '@lib/containers/Login';
import LostPassword from '@lib/containers/LostPassword';
import Output from '@lib/containers/Output';
import RecipientList from '@lib/containers/RecipientList';
import Register from '@lib/containers/Register';
import Schedule from '@lib/containers/Schedule';
import SiteAdd from '@lib/containers/SiteAdd';
import SiteEdit from '@lib/containers/SiteEdit';
import Status from '@lib/containers/Status';
import Temperature from '@lib/containers/Temperature';
import Thermostat from '@lib/containers/Thermostat';
import User from '@lib/containers/User';
import Rules from '@lib/pages/Rules';
import { authenticationReducer } from '@lib/reducers/authenticationReducer';
import { siteReducer } from '@lib/reducers/siteReducer';
import { IStoreState } from '@lib/types/index';
import 'core-js/es6/map';
import 'core-js/es6/set';
import { createHashHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import './index.css';
import registerServiceWorker from './registerServiceWorker';


const history = createHashHistory();

declare var Waves: any;
Waves.init();


const rootReducer = combineReducers<IStoreState>({
  authentication: authenticationReducer,
  site: siteReducer
});


const store = createStore<IStoreState>(rootReducer, {
  authentication: {
    confirmation: '',
    login: localStorage.login ? localStorage.login : '',
    password: localStorage.password ? localStorage.password : '',
    rememberMe: localStorage.rememberMe === 'false' ? false : true,
  }, site: { pendingOrder: 0 },
}, composeWithDevTools(
  applyMiddleware(thunkMiddleware)));

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter store={store} history={history}>
      <Switch>
        <Route path={'/login'} component={Login} />
        <Route path={'/register'} component={Register} />
        <Route path={'/lostPassword'} component={LostPassword} />
        <Route path={'/changePassword'} component={ChangePassword} />
        <Route path={'/home'} component={Home} />
        <Route path={'/dashboard'} component={DashBoard} />
        <Route path={'/temperature'} component={Temperature} />
        <Route path={'/planning'} component={Schedule} />
        <Route path={'/thermostat'} component={Thermostat} />
        <Route path={'/output'} component={Output} />
        <Route path={'/input'} component={Input} />
        <Route path={'/logEvent'} component={LogEvent} />
        <Route path={'/recipientList'} component={RecipientList} />
        <Route path={'/siteAdd'} component={SiteAdd} />
        <Route path={'/siteEdit'} component={SiteEdit} />
        <Route path={'/sms'} component={Sms} />
        <Route path={'/status'} component={Status} />
        <Route path={'/alarm'} component={Alarm} />
        <Route path={'/user'} component={User} />
        <Route path={'/rules'} component={Rules} />
        <Route default={true} component={Login} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx